// @flow
import type { SetResult } from '../types/Results';
import type { Document } from '../types/Document';

export const RESULTS_LOADING = 'results/LOADING';
export const RESULTS_SUCCESS = 'results/SUCCESS';
export const RESULTS_ERROR = 'results/ERROR';

type State = {
  loading: boolean,
  documents: Array<Document>,
  pagination: {
    currentPage: number,
    pageCount: number,
    documentsPerPage: number,
    documentCount: number,
    totalDocumentCourt: number
  },
  error: ''
};

type Action = {
  type: string,
  payload: SetResult
};

const initialState: State = {
  loading: false,
  documents: [],
  pagination: {
    currentPage: 0,
    pageCount: 0,
    documentsPerPage: 0,
    documentCount: 0,
    totalDocumentCourt: 0
  },
  error: ''
};

function reducer(state: State = initialState, action: Action) {
  const { type, payload } = action;

  switch (type) {
    case RESULTS_LOADING:
      return {
        ...state,
        loading: true
      };

    case RESULTS_SUCCESS:
      return {
        ...state,
        ...payload,
        loading: false
      };

    case RESULTS_ERROR:
      return {
        ...state,
        ...payload,
        loading: false
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/results.js